import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddIntegrationLayer from "../components/AddIntegrationLayer";


const AddIntegrationPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Add Integration" />

        {/* AddIntegration */}
        <AddIntegrationLayer />


      </MasterLayout>
    </>
  );
};

export default AddIntegrationPage;
